// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var List        = require("bs-platform/lib/js/list.js");
var $$Array     = require("bs-platform/lib/js/array.js");
var Block       = require("bs-platform/lib/js/block.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var Input       = require("../ffi/Input");
var React       = require("react");
var $$String    = require("bs-platform/lib/js/string.js");
var DateFns     = require("date-fns");
var Caml_array  = require("bs-platform/lib/js/caml_array.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./AddMealScreen.css')));

var component = ReasonReact.reducerComponent("AddMealScreen");

function setHourMinutes(timestamp, hours, minutes) {
  return new Date(new Date(timestamp).setMinutes(minutes)).setHours(hours);
}

function toDateString(timestamp) {
  return DateFns.format(new Date(timestamp), "YYYY-MM-DD");
}

function toTimeString(timestamp) {
  return DateFns.format(new Date(timestamp), "HH:mm");
}

function make(quickAddMeal, _) {
  var changeDate = function (evt, self) {
    var date = new Date(Input.value(evt));
    var oDate = new Date(self[/* state */2][/* timestamp */1]);
    var newTimestamp = setHourMinutes(date.getTime(), oDate.getHours(), oDate.getMinutes());
    return Curry._1(self[/* send */4], /* SetTimestamp */Block.__(1, [newTimestamp]));
  };
  var changeTime = function (evt, self) {
    var x = $$Array.map(Caml_format.caml_float_of_string, Input.value(evt).split(":"));
    var newTimestamp = setHourMinutes(self[/* state */2][/* timestamp */1], Caml_array.caml_array_get(x, 0), Caml_array.caml_array_get(x, 1));
    return Curry._1(self[/* send */4], /* SetTimestamp */Block.__(1, [newTimestamp]));
  };
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (self) {
      return React.createElement("div", undefined, React.createElement("div", {
                      className: "ams-title"
                    }, React.createElement("h1", undefined, "Add Meal")), React.createElement("form", {
                      className: "ams-form"
                    }, React.createElement("div", {
                          className: "ams-input ams-name-input"
                        }, React.createElement("label", undefined, "Name"), React.createElement("input", {
                              value: self[/* state */2][/* name */0],
                              onChange: (function (evt) {
                                  return Curry._1(self[/* send */4], /* SetName */Block.__(0, [Input.value(evt)]));
                                })
                            })), React.createElement("div", {
                          className: "ams-input ams-multi-input"
                        }, React.createElement("div", {
                              className: "ams-input-entry ams-date-input"
                            }, React.createElement("label", undefined, "Date"), React.createElement("input", {
                                  type: "date",
                                  value: DateFns.format(new Date(self[/* state */2][/* timestamp */1]), "YYYY-MM-DD"),
                                  onChange: Curry._1(self[/* handle */0], changeDate)
                                })), React.createElement("div", {
                              className: "ams-input-entry"
                            }, React.createElement("label", undefined, "Time"), React.createElement("input", {
                                  type: "time",
                                  value: DateFns.format(new Date(self[/* state */2][/* timestamp */1]), "HH:mm"),
                                  onChange: Curry._1(self[/* handle */0], changeTime)
                                }))), React.createElement("div", {
                          className: "ams-input"
                        }, React.createElement("label", undefined, "Categories"), React.createElement("textarea", {
                              placeholder: "Comma separated value of categories, e.g: lunch, steak, beef",
                              value: self[/* state */2][/* categories */2],
                              onChange: (function (evt) {
                                  return Curry._1(self[/* send */4], /* SetCategories */Block.__(2, [Input.value(evt)]));
                                })
                            })), React.createElement("button", undefined, "Submit")));
    });
  newrecord[/* initialState */10] = (function () {
      if (quickAddMeal) {
        var meal = quickAddMeal[0];
        return /* record */[
                /* name */meal.name,
                /* timestamp */meal.timestamp,
                /* categories */$$String.concat(", ", List.map((function (c) {
                            return c.name;
                          }), meal.categories))
              ];
      } else {
        return /* record */[
                /* name */"",
                /* timestamp */Date.now(),
                /* categories */""
              ];
      }
    });
  newrecord[/* reducer */12] = (function (action, state) {
      switch (action.tag | 0) {
        case 0 : 
            return /* Update */Block.__(0, [/* record */[
                        /* name */action[0],
                        /* timestamp */state[/* timestamp */1],
                        /* categories */state[/* categories */2]
                      ]]);
        case 1 : 
            return /* Update */Block.__(0, [/* record */[
                        /* name */state[/* name */0],
                        /* timestamp */action[0],
                        /* categories */state[/* categories */2]
                      ]]);
        case 2 : 
            return /* Update */Block.__(0, [/* record */[
                        /* name */state[/* name */0],
                        /* timestamp */state[/* timestamp */1],
                        /* categories */action[0]
                      ]]);
        
      }
    });
  return newrecord;
}

exports.component      = component;
exports.setHourMinutes = setHourMinutes;
exports.toDateString   = toDateString;
exports.toTimeString   = toTimeString;
exports.make           = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/screen/AddMealScreen.re
// module id = 266
// module chunks = 0